import { createContext } from 'react';

/**
 * Bumped by FormShell each time Next is pressed on a step that is not finished yet. Every field
 * on screen re-runs its own on-blur check when it changes, so the advisor sees exactly what is
 * missing or wrong, in place (QA D-36: Next used to sit disabled with no word of why). Zero means
 * "not asked yet", so a fresh step starts without red.
 *
 * A context rather than a prop so revealed and nested fields hear it too, without threading a
 * value through every renderer between the shell and the input.
 */
export const ShowErrorsContext = createContext(0);
